module.exports = __webpack_public_path__ + "static/media/22.837a6847.png";